export const loadingGrey = '#9999a2';
export const searchHeaderIconGrey = '#999999';
export const componentHeaderGrey = '#CCCCCC';
export const borderGrey = '#e0e0e0';
export const searchHeaderBorderGrey = '#DDDDDD';
export const adminPaneGrey = '#F2F4F7';
export const rightPaneAttributeBackground = description => {
  const backgroundColor = {
    salvation: '#999999',
    baptism: '#2D9CDB',
    'courses taken': '#E81B55',
  };

  return backgroundColor[description] || '#999999';
};
export const rightPaneAttributecolor = 'white';
